import React, { Component } from 'react';
import moment from 'moment';
import './Results.css';

class Results extends Component {
  renderRows(term) {
    const period = this.props.data[term];
    const rows = period.sales_events.map(row => {
      return (
        <tr key={Math.random()}>
          <td>
            {row.description}
          </td>
          <td>
            {moment(row.date_purchased).format('MM/DD/YY')}
          </td>
          <td>
            {moment(row.date_sold).format('MM/DD/YY')}
          </td>
          <td>
            {row.proceeds}
          </td>
          <td>
            {row.cost_basis}
          </td>
          <td>
            {row.profit_or_loss}
          </td>
        </tr>
      );
    });

    rows.push(
      <tr key="last">
        <td />
        <td />
        <td />
        <td style={{ fontWeight: 'bold' }}>
          {period.total_proceeds}
        </td>
        <td style={{ fontWeight: 'bold' }}>
          {period.total_cost_basis}
        </td>
        <td style={{ fontWeight: 'bold' }}>
          {period.capital_gains}
        </td>
      </tr>
    );

    return (
      <table>
        <thead>
          <tr>
            <td className="table-header">Description</td>
            <td className="table-header">Date acquired</td>
            <td className="table-header">Date sold</td>
            <td className="table-header">Proceeds</td>
            <td className="table-header">Cost basis</td>
            <td className="table-header">Gain/loss</td>
          </tr>
        </thead>

        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className="results">
        <div className="results__term-section">
          <div className="results__title">Short-Term</div>
          {this.renderRows('short_term')}
        </div>

        <div className="results__term-section">
          <div className="results__title">Long-Term</div>
          {this.renderRows('long_term')}
        </div>
      </div>
    );
  }
}

export default Results;



// WEBPACK FOOTER //
// ./src/Results.js